module.exports = __webpack_public_path__ + "img/l_s5.a0695c01.png";